import { i18nKeys } from 'translationTypes'
import i18n from '../../../i18n'

export default {
  logIn: () => i18n.t(i18nKeys.common__logIn),
  signUp: () => i18n.t(i18nKeys.common__signup),
  support: () => i18n.t(i18nKeys.inAppEducation__support__title),
  faq: () => i18n.t(i18nKeys.idv_failure_faq),
}
